export default __webpack_public_path__ + "static/media/staff-user-red.97c0fdaa.svg";